import { PageTextContentType } from '../../../hooks/useContentMgmt';
import { convertValidationRules } from '../../../hooks/useFormState';
import { validateEmail } from '../../../util/form-validation';

export interface ForgotPasswordFormModel {
  email: string;
  pinId: string;
}

export interface VerifyPasswordFormModel {
  newPassword: string;
  otp: string;
}

type AdditionalContext = {
  content: PageTextContentType;
};

// ---------- Forgot Password Rules ----------
export const forgotPasswordRules = convertValidationRules<
  ForgotPasswordFormModel,
  AdditionalContext
>((context) => ({
  email: validateEmail,

  pinId: (value) => {
    if (!value) {
      return context.content.get('ENTER_PIN_ID');
    }
    return null;
  },
}));

// ---------- Verify Password Rules ----------
export const verifyPasswordRules = convertValidationRules<
  VerifyPasswordFormModel,
  AdditionalContext
>((context) => ({
  newPassword: (value) => {
    if (!value) {
      return context.content.get('ENTER_NEW_PASSWORD');
    }
    // Example password policy (you can adjust this)
    if (value.length < 8) {
      return context.content.get('PASSWORD_TOO_SHORT');
    }
    return null;
  },

  otp: (value) => {
    if (!value) {
      return context.content.get('ENTER_OTP');
    }

    // If OTP must be 6 digits
    if (value.length !== 6){ 
      return context.content.get('INVALID_OTP');
    }

    return null;
  },
}));
